import { Navigate, useParams } from 'react-router-dom'
import ContentPage from '@/components/ContentPage'
import { getFeature } from '@/content/features'

export default function FeatureDetailPage() {
  const { slug } = useParams()
  const feature = getFeature(slug)

  if (!feature) {
    return <Navigate to="/features" replace />
  }

  return (
    <ContentPage
      path={feature.path}
      seoTitle={feature.seoTitle}
      seoDescription={feature.seoDescription}
      heroTitle={feature.title}
      heroDescription={feature.intro}
      images={feature.images}
      eyebrow="Feature"
      sections={feature.sections}
      sectionLayout={feature.sectionLayout || 'images'}
      detailTabs={feature.detailTabs}
      relatedFeatureSlugs={feature.related}
      resourceLinks={feature.resourceLinks || []}
      jsonLd={{
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: `Tillio POS — ${feature.title}`,
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'iPadOS',
        description: feature.seoDescription,
        url: `https://tilliopayment.com${feature.path}`,
        offers: {
          '@type': 'Offer',
          price: '99.00',
          priceCurrency: 'USD',
        },
      }}
    />
  )
}
